import { formatNumber } from "../../utils/utils";

export type LoyaltyPointSummary = {
  availablePoints: number;
  pendingPoints: number;
  lifetimeEarnedPoints: number;
  lifetimeRedeemedPoints: number;
};

export type LoyaltyPointTransaction = {
  id: number;
  type: string;
  status: string;
  points: number;
  balanceAfter: number;
  sourceType?: string;
  sourceId?: number;
  orderId?: number;
  outletId?: number;
  serviceId?: number;
  quantity?: number;
  description?: string;
  createdDate?: string;
};

export const defaultLoyaltySummary: LoyaltyPointSummary = {
  availablePoints: 0,
  pendingPoints: 0,
  lifetimeEarnedPoints: 0,
  lifetimeRedeemedPoints: 0,
};

export const unwrap = (response: any) => response?.data?.data ?? response?.data ?? response;

export const unwrapPageItems = (payload: any): LoyaltyPointTransaction[] => {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.content)) return payload.content;
  if (Array.isArray(payload?.data)) return payload.data;
  return [];
};

export const unwrapPageTotal = (payload: any, fallback: number) =>
  payload?.total_elements ?? payload?.totalElements ?? payload?.total ?? fallback;

export const formatPoints = (value?: number) => formatNumber(value || 0);
